/**
 * Programs sit above streams and are needed by the stream form, the subject
 * list and the plan form. One hook, one query, cached by Refine.
 */
import { useList } from '@refinedev/core'
import type { Program } from '@/types'

export function usePrograms() {
  const { data, isLoading } = useList<Program>({
    resource: 'programs',
    pagination: { mode: 'off' },
    sorters: [{ field: 'sort_order', order: 'asc' }],
    filters: [{ field: 'is_active', operator: 'eq', value: true }],
  })

  return { programs: data?.data ?? [], isLoading }
}
